import React from 'react';
import { Award, GraduationCap, Heart } from 'lucide-react';
export function PhysicianProfileAnyaoku() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-[#f8faff] dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-737">
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6" data-id="element-738">
        <div className="container mx-auto max-w-6xl" data-id="element-739">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-740">
            {/* Image */}
            <div className="flex justify-center" data-id="element-741">
              <div className="relative" data-id="element-742">
                <div className="absolute inset-0 bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-2xl blur-2xl opacity-20" data-id="element-743"></div>
                <img src="https://cdn.magicpatterns.com/uploads/8EREnhaHSiE5sSQfjKeRG1/headshot.jpg" alt="Dr. Jacinta Anyaoku" className="relative rounded-2xl shadow-2xl w-full max-w-md" data-id="element-744" />
              </div>
            </div>

            {/* Info */}
            <div data-id="element-745">
              <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-746">
                <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-747">
                  Dr. Jacinta Anyaoku, MD, DABOM
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 mb-6" data-id="element-748">
                Board Certified Family Medicine & Obesity Medicine Physician
              </p>
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 mb-8" data-id="element-749">
                <Heart className="text-[#C85A15]" size={20} data-id="element-750" />
                <span data-id="element-751">
                  15+ years of clinical experience, 8+ years in telemedicine
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-16 px-6" data-id="element-752">
        <div className="container mx-auto max-w-4xl" data-id="element-753">
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-754">
            <div className="flex items-center gap-3 mb-6" data-id="element-755">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-756">
                <Heart className="text-[#C85A15]" size={24} data-id="element-757" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-758">About Dr. Anyaoku</h2>
            </div>
            <div className="space-y-4 text-gray-600 dark:text-gray-300 text-lg leading-relaxed" data-id="element-759">
              <p data-id="element-760">
                Jacinta Anyaoku, MD, DABOM is a board-certified physician in
                Family Medicine and Obesity Medicine with over 15 years of
                clinical experience and more than 8 years providing care through
                telemedicine. She practices a whole-person approach to care,
                supporting patients with medical weight loss as well as broader
                wellness needs, including hormone optimization, metabolic
                health, and longevity care, using evidence-based, personalized
                strategies.
              </p>
              <p data-id="element-761">
                Dr. Anyaoku is committed to helping patients feel informed,
                supported, and confident in their care. Outside of medicine, she
                enjoys spending time with her husband and two sons, traveling,
                and exploring her local foodie scene.
              </p>
            </div>
          </div>

          {/* Certifications Section */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-762">
            <div className="flex items-center gap-3 mb-8" data-id="element-763">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-764">
                <Award className="text-[#BBDDFF]" size={24} data-id="element-765" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-766">Board Certifications</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-767">
              <div className="flex items-start gap-3" data-id="element-768">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-769" />
                <div data-id="element-770">
                  <h3 className="font-semibold mb-1" data-id="element-771">Board Certified</h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-772">
                    Family Medicine
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-773">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-774" />
                <div data-id="element-775">
                  <h3 className="font-semibold mb-1" data-id="element-776">Diplomate</h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-777">
                    American Board of Obesity Medicine (DABOM)
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Areas of Expertise */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-778">
            <div className="flex items-center gap-3 mb-8" data-id="element-779">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-780">
                <GraduationCap className="text-[#BBDDFF]" size={24} data-id="element-781" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-782">Areas of Expertise</h2>
            </div>
            <div className="space-y-4" data-id="element-783">
              <div className="flex items-center gap-3" data-id="element-784">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-785"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-786">
                  <span className="font-semibold" data-id="element-787">Medical Weight Loss</span> –
                  Evidence-based, personalized weight management strategies
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-788">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-789"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-790">
                  <span className="font-semibold" data-id="element-791">Hormone Optimization</span> –
                  Comprehensive hormone replacement and optimization therapy
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-792">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-793"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-794">
                  <span className="font-semibold" data-id="element-795">Metabolic Health</span> –
                  Addressing metabolic conditions and optimizing overall health
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-796">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-797"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-798">
                  <span className="font-semibold" data-id="element-799">Longevity Care</span> –
                  Whole-person approach to healthy aging and wellness
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-800">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-801"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-802">
                  <span className="font-semibold" data-id="element-803">Telemedicine</span> – 8+ years
                  of experience delivering high-quality virtual care
                </p>
              </div>
            </div>
          </div>

          {/* Philosophy of Care */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-804">
            <div className="flex items-center gap-3 mb-8" data-id="element-805">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-806">
                <Heart className="text-[#BBDDFF]" size={24} data-id="element-807" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-808">Philosophy of Care</h2>
            </div>
            <div className="space-y-4" data-id="element-809">
              <div className="flex items-center gap-3" data-id="element-810">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-811"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-812">
                  <span className="font-semibold" data-id="element-813">Whole-Person Approach</span> –
                  Addresses all aspects of patient wellness, not just symptoms
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-814">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-815"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-816">
                  <span className="font-semibold" data-id="element-817">Evidence-Based Care</span> –
                  Uses proven, personalized strategies for optimal outcomes
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-818">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-819"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-820">
                  <span className="font-semibold" data-id="element-821">Patient Empowerment</span> –
                  Committed to helping patients feel informed, supported, and
                  confident
                </p>
              </div>
            </div>
          </div>

          {/* Licensed States */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-822">
            <div className="flex items-center gap-3 mb-8" data-id="element-823">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-824">
                <Award className="text-[#C85A15]" size={24} data-id="element-825" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-826">Licensed in 10 States</h2>
            </div>
            <div className="flex flex-wrap gap-3" data-id="element-827">
              {['NC', 'TX', 'LA', 'CA', 'CO', 'CT', 'FL', 'IN', 'ME', 'MI'].map(state => <span key={state} className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-828">
                    {state}
                  </span>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6" data-id="element-829">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-830">
          <div className="bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 rounded-2xl p-12 border border-white/20 dark:border-gray-700/30" data-id="element-831">
            <h2 className="text-3xl font-bold mb-4" data-id="element-832">
              Ready to Start Your Journey?
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-833">
              Dr. Anyaoku is here to support you with personalized care tailored
              to your needs.
            </p>
            <a href="https://app.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all" data-id="element-834">
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </div>;
}